
$(document).ready(function(){
  
   function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
  function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

if(getCookie('popup') != 'true' && window.location.href.indexOf('challenge#contact_form') == -1){
    $(".custom-popup").delay(2000).show();
    //  setCookie('popup', 'true', 1);
}
/* Checkout popup START CODE  */
// $(document).on('click',"#ctm-checkout_jtpl",function(){
//   $(".checkout-popup").addClass('checkout_model-open');
// });
$(document).on('click', "#ctm-checkout_jtpl", function (e) {
    e.preventDefault();
    if ($('.checkout-popup').length === 0) {
        window.location.href = '/checkout';
        return;
    }

    $(".checkout-popup").addClass('checkout_model-open');
});
if($('.checkout-popup').length == 0){
   $('#CartDrawer-Checkout').show();
  $('#ctm-checkout_jtpl').hide();
}
   
$(document).on('click',".checkout_popup-close-btn , .checkout_no-thanks-btn , .checkout-popup-atc" ,function(){
   window.location.href='/checkout';
  $(".checkout-popup").removeClass('checkout_model-open');
 // $('#CartDrawer-Checkout').show();
  //$('#ctm-checkout_jtpl').hide();
 
 //setCookie('checkout_popup', 'true', 1);
});
 
 $(document).mouseup(function (e) { 
            if ($(e.target).closest(".checkout-popup-inner").length === 0 && $(".checkout-popup").hasClass('checkout_model-open')) { 
         window.location.href='/checkout';
              $(".checkout-popup").removeClass('checkout_model-open');
           // setCookie('checkout_popup', 'true', 1);
          //  $('.checkout_popup-close-btn').trigger('click');
              
            } 
        }); 

// if(getCookie('checkout_popup') == 'true' ){
//    $('.checkout-popup').removeClass('checkout_model-open');
//     $('#CartDrawer-Checkout').show();
//     $('#ctm-checkout_jtpl').hide();

// }

/* Checkout popup END CODE  */

/* Welcome PopUp START CODE */
  $(".announcement-bar__message a").click(function(e){
   if($(this).attr('href').indexOf('#') >-1){
      e.preventDefault();
      $('.custom-popup').addClass('model-open').show(); 
    }
    
   
  });
$(".popup-close-btn ,.no-thanks-btn").click(function(e){
e.preventDefault();
  $(".custom-popup").removeClass('model-open');
  var data_url = window.location.href;
var main_url = data_url.split('?')[0];
console.log(main_url) ;
window.history.pushState({}, '', main_url);
  setCookie('popup', 'true', 1);
});



   $(document).mouseup(function (e) { 
    var recommended_data =  $(".recommendation-modal__container").html();
            if ($(e.target).closest(".custom-popup-inner").length === 0 && typeof recommended_data == 'undefined' ) { 
       $(".custom-popup").removeClass('model-open');
  var data_url = window.location.href;
var main_url = data_url.split('?')[0];
console.log(main_url) ;
// window.history.pushState({}, '', main_url);
window.history.replaceState({}, '', main_url);
  setCookie('popup', 'true', 1);
  
              
            } 
        }); 

/*Welcome PopUp END CODE*/
 
  /** slider btn ****/
  $(window).on("load resize scroll",function(e){
var img_height = $('.about-multicol .multicolumn-card__image-wrapper').height();
var half_hight = img_height/2;
$('.about-multicol .slider-buttons').css("top",half_hight);
});
 /** slider btn End****/
 

  if($(window).width() > 1024){
  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
   items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      if($('.mega-menu-image-slider.slick-initialized',item).length > 0){
        $('.mega-menu-image-slider',item).slick('unslick');
        $('.mega-menu-image-slider',item).slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true,
          prevArrow:'<button type="button" class="slick-prev pull-left"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
         nextArrow:'<button type="button" class="slick-next pull-right"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>'
        });
      }
       window.dispatchEvent(new Event("resize"));
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  });
  }else{
      let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
   items.forEach(item => {
    item.addEventListener("click", () => {
      if($('.mega-menu-image-slider.slick-initialized',item).length > 0){
        $('.mega-menu-image-slider',item).slick('unslick');
        $('.mega-menu-image-slider',item).slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true,
          prevArrow:'<button type="button" class="slick-prev pull-left"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
         nextArrow:'<button type="button" class="slick-next pull-right"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>'
        });
      }
    });
   });  
  }
              
   function eventFire(el, etype){
 console.log(el);
  if (el.fireEvent) {
    el.fireEvent('on' + etype);
  } else {
    var evObj = document.createEvent('Events');
    evObj.initEvent(etype, true, false);
    el.dispatchEvent(evObj);
  }
}
if($('.mega-menu-image-slider').length > 0){
$('.mega-menu-image-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true,
  prevArrow:'<button type="button" class="slick-prev pull-left"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
 nextArrow:'<button type="button" class="slick-next pull-right"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>'
});
}
/** One tab open at a time**/
$('.accordion details').click(function(){
      $(this).attr('open');
    $(this).parent('.accordion').siblings().find('details').removeAttr('open');
});
/** One tab open at a time END Code**/
setTimeout(() => {
    // Create a new wrapper div
    const wrapper = document.createElement('div');
    wrapper.classList.add('custom-wrapper'); // You can add a custom class here if needed

    // Select the two divs you want to wrap
    const looxRatingDiv = document.querySelector('.shopify-block.shopify-app-block');
    const priceDiv = document.querySelector('.price_cstm-sct');

    // Select the target container (product__info-container)
    const productInfoContainer = document.querySelector('.product__info-container');
    
    // Select the product title (product__title)
    const productTitle = document.querySelector('.product__title');

    // Check if all required elements exist
    if (looxRatingDiv && priceDiv && productInfoContainer && productTitle) {
        // Append the two divs to the wrapper
        wrapper.appendChild(looxRatingDiv);
        
        wrapper.appendChild(priceDiv);

        // Insert the wrapper after the product title
        productInfoContainer.insertBefore(wrapper, productTitle.nextSibling);
    } else {
        console.log('One or more elements not found.');
    }
}, 1000); // Delay of 100 milliseconds


// $(".wall-calulator").click(function () {
//   $(".success_msg , .wall_error").remove();
//   var width = $.trim($("#wallpaper-width").val());
//   var height = $.trim($("#wallpaper-height").val());
//   if (
//     width != undefined &&
//     width != "" &&
//     height != undefined &&
//     height != ""
//   ) {
//     if (isNaN(width) == true || isNaN(height) == true) {
//       $('<p class="error wall_error">Please enter a valid number</p>').insertAfter($(this));
//     } else {
//       var roll = Math.ceil(width / 24);
//       height = parseInt(height);
//       var w1 = 24;

//       if (height < 24) {
//         height = 36;
//       }

//       if (height >= 24 && height <= 36) {
//         height = 36;
//       } else if (height >= 37 && height <= 48) {
//         height = 48;
//       } else if (height >= 49 && height <= 60) {
//         height = 60;
//       } else if (height >= 61 && height <= 72) {
//         height = 72;
//       } else if (height >= 73 && height <= 84) {
//         height = 84;
//       } else if (height >= 85 && height <= 96) {
//         height = 96;
//       } else if (height >= 97 && height <= 108) {
//         height = 108;
//       } else if (height >= 109 && height <= 120) {
//         height = 120;
//       } else if (height >= 121 && height <= 132) {
//         height = 132;
//       } else if (height >= 133 && height <= 144) {
//         height = 144;
//       } else {
//         height = parseInt(height);
//       }

// var message = `<p class="success_msg">Total required is: ${roll} rolls of ${w1}"x${height}"</p>`;
// $(".wallpaper-size-calculator").append(message);

// // Update the visible dropdown label
// $('.selectedOption').first().text(`${w1}"x${height}"`).attr('data-selected_option_val', `${w1}"x${height}"`);

// // ==== AUTO UPDATE SHOPIFY QUANTITY ====
// let qty = document.querySelector('.quantity__input');

// if (qty) {
//     qty.value = roll;
//     qty.dispatchEvent(new Event('input', { bubbles: true }));
//     qty.dispatchEvent(new Event('change', { bubbles: true }));
// }

// $('input[name="quantity"]').val(roll).trigger('change');

// const addBtn = document.querySelector(".product-form__submit");
// if (addBtn) {
//     addBtn.disabled = false;
//     addBtn.classList.remove("disabled");
//     addBtn.removeAttribute("aria-disabled");
// }

//       // Update the visible dropdown label
//       $('.selectedOption').first().text(`${w1}"x${height}"`).attr('data-selected_option_val', `${w1}"x${height}"`);

//       // Also update the underlying select dropdown
//       var $select = $('.select__select');
//       var newVal = `${w1}"x${height}"`;

//       // Try to select option if exists
//       var optionExists = false;
//       $select.find('option').each(function () {
//         if ($(this).text() === newVal) {
//           $(this).prop('selected', true);
//           optionExists = true;
//           return false; // break loop
//         }
//       });

//       // If option doesn't exist, optionally add it
//       if (!optionExists) {
//         $select.append(new Option(newVal, newVal, true, true));
//       }
      
//       $select.val(newVal).trigger('change');
//     }
//   } else {
//     if (width == undefined || width == "") {
//       $("#wallpaper-width").parent(".field").addClass("error");
//     }
//     if (height == undefined || height == "") {
//       $("#wallpaper-height").parent(".field").addClass("error");
//     }
//     $('<p class="error wall_error">Please fill the above fields</p>').insertAfter($(this));
//   }
//    var textArray = [];

// $(".selectedOption").each(function() {
//   var text = $(this).text().trim();      
//   var firstPart = text.split('/')[0].trim(); 
//   textArray.push(firstPart);
// });

// console.log("textArray:", textArray);

// $(".form_input_variants").find("select option").each(function(index, ele) {
//   var text = $(ele).text().trim(); // Full option text
//   var value = $(ele).val();        // Option value

//   // Remove price after '-'
//   var cleaned = text.split('-')[0].trim();

//   // Split by '/'
//   var parts = cleaned.split('/');
//   if (parts.length >= 2) {
//     var part1 = parts[0].trim();
//     var part2 = parts[1].trim();

//     // Check if both part1 and part2 exist in textArray
//     if (textArray.includes(part1) && textArray.includes(part2)) {
//       console.log("Matched Option Value:", value, "Part1:", part1, "Part2:", part2);

//       // Set the value to the select element with name="id"
//       $(".variant_select_cstm").find('input[name="id"]').val(value).trigger('change');
//     }
//   }
// });
// });


$(".wall-calulator").click(function () {
$(".success_msg , .wall_error").remove();
 // var width = $.trim($("#wallpaper-width").val()); //clarity
 var width = ($("#wallpaper-width").val() || "").trim();
var height = ($("#wallpaper-height").val() || "").trim();

  if (
    width != undefined &&
    width != "" &&
    height != undefined &&
    height != ""
  ) {
    if (isNaN(width) == true || isNaN(height) == true) {
      $('<p class="error wall_error">Please enter a valid number</p>').insertAfter($(this));
    } else {
      var roll = Math.ceil(width / 24);
      height = parseInt(height);
      var w1 = 24;

      if (height < 24) {
        height = 36;
      }

      if (height >= 24 && height <= 36) {
        height = 36;
      } else if (height >= 37 && height <= 48) {
        height = 48;
      } else if (height >= 49 && height <= 60) {
        height = 60;
      } else if (height >= 61 && height <= 72) {
        height = 72;
      } else if (height >= 73 && height <= 84) {
        height = 84;
      } else if (height >= 85 && height <= 96) {
        height = 96;
      } else if (height >= 97 && height <= 108) {
        height = 108;
      } else if (height >= 109 && height <= 120) {
        height = 120;
      } else if (height >= 121 && height <= 132) {
        height = 132;
      } else if (height >= 133 && height <= 144) {
        height = 144;
      } else {
        height = parseInt(height);
      }
var message = `<p class="success_msg">Total required is: ${roll} rolls of ${w1}"x${height}"</p>`;
$("#calculatorPopup .wallpaper-size-calculator-popup .contact__button").append(message);

$("#wallpaper_calculator .wallpaper_cal_wrapper .contact__button").append(message);
$(".custm-hotel-motel-landing .wallpaper_cal_wrapper .contact__button").append(message);
// Update the visible dropdown label
$('.selectedOption').first().text(`${w1}"x${height}"`).attr('data-selected_option_val', `${w1}"x${height}"`);

// ==== AUTO UPDATE SHOPIFY QUANTITY ====
let qty = document.querySelector('.quantity__input');

if (qty) {
    qty.value = roll;
    qty.dispatchEvent(new Event('input', { bubbles: true }));
    qty.dispatchEvent(new Event('change', { bubbles: true }));
}

$('input[name="quantity"]').val(roll).trigger('change');

const addBtn = document.querySelector(".product-form__submit");
if (addBtn) {
    addBtn.disabled = false;
    addBtn.classList.remove("disabled");
    addBtn.removeAttribute("aria-disabled");
}

      // Update the visible dropdown label
      $('.selectedOption').first().text(`${w1}"x${height}"`).attr('data-selected_option_val', `${w1}"x${height}"`);

      // Also update the underlying select dropdown
      var $select = $('.select__select');
      var newVal = `${w1}"x${height}"`;

      // Try to select option if exists
      var optionExists = false;
      $select.find('option').each(function () {
        if ($(this).text() === newVal) {
          $(this).prop('selected', true);
          optionExists = true;
          return false; // break loop
        }
      });

      // If option doesn't exist, optionally add it
      if (!optionExists) {
        $select.append(new Option(newVal, newVal, true, true));
      }
      
      $select.val(newVal).trigger('change');
    }
  } else {
    if (width == undefined || width == "") {
      $("#wallpaper-width").parent(".field").addClass("error");
    }
    if (height == undefined || height == "") {
      $("#wallpaper-height").parent(".field").addClass("error");
    }
    $('<p class="error wall_error">Please fill the above fields</p>').insertAfter($(this));
  }
   var textArray = [];

$(".selectedOption").each(function() {
  var text = $(this).text().trim();      
  var firstPart = text.split('/')[0].trim(); 
  textArray.push(firstPart);
});

// console.log("textArray:", textArray);

$(".form_input_variants").find("select option").each(function(index, ele) {
  var text = $(ele).text().trim(); // Full option text
  var value = $(ele).val();        // Option value

  // Remove price after '-'
  var cleaned = text.split('-')[0].trim();

  // Split by '/'
  var parts = cleaned.split('/');
  if (parts.length >= 2) {
    var part1 = parts[0].trim();
    var part2 = parts[1].trim();

    // Check if both part1 and part2 exist in textArray
    if (textArray.includes(part1) && textArray.includes(part2)) {
      // console.log("Matched Option Value:", value, "Part1:", part1, "Part2:", part2);

      // Set the value to the select element with name="id"
      $(".variant_select_cstm").find('input[name="id"]').val(value).trigger('change');
    }
  }
});

});



/** Add attribute to the product form**/

$('.product-form__buttons button').click(function(e){
  $(this).parents('.product-form').attr('data-type',$(this).attr('data-type'));
  
});

// function initVariantBox() {
//   const boxes = document.querySelectorAll('.cstm-sample-wrapper .cstm-sample-variant');
//   if (!boxes.length) return;

// function selectBox(box) {
//   const variantEl = box.querySelector('.cstm-sample-variant-id');
//   const variantId = variantEl?.dataset?.id || variantEl?.id;
  
//   if (!variantId) return;

//   // Active class
//   document.querySelectorAll('.cstm-sample-variant')
//     .forEach(b => b.classList.remove('active'));
//   box.classList.add('active');

//   // Update hidden inputs
//   document.querySelectorAll('input[name="id"]').forEach(input => {
//     input.value = variantId;
//   });

//   // ✅ Target the correct variant-selects internal selects
//   const variantSelectEl = document.querySelector('variant-selects');
//   if (variantSelectEl) {
//     const selects = variantSelectEl.querySelectorAll('select');
//     let matched = false;

//     selects.forEach(select => {
//       Array.from(select.options).forEach(opt => {
//         // Match by checking if this option belongs to a variant containing 'sample'
//         if (opt.value === variantId) {
//           select.value = opt.value;
//           matched = true;
//         }
//       });
//     });

//     if (matched) {
//       // Fire change on the variant-selects container itself
//       variantSelectEl.dispatchEvent(new Event('change', { bubbles: true }));
//     }
//   }

//   // Button data-vid updates
//   const btn = document.querySelector('.cstm-sample-button');
//   if (btn) btn.setAttribute('data-vid', variantId);

//   const popupBtn = document.querySelector('.popup_product_form .sample_button');
//   if (popupBtn) popupBtn.dataset.vid = variantId;

//   // Availability
//   const variantAvailable = variantEl?.dataset?.available;
//   if (btn) {
//     btn.classList.toggle('disabled', variantAvailable === 'false');
//   }

//   // Price
//   const variantPrice = variantEl?.dataset?.price;
//   if (variantPrice) {
//     const priceEl = document.querySelector('.cstm-sample-price-value');
//     if (priceEl) {
//       const currency = window.Shopify?.currency?.active || 'INR';
//       const value = Number(variantPrice) / 100;
//       priceEl.textContent = currency === 'INR'
//         ? `Rs. ${value.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`
//         : value.toLocaleString('en-IN', { style: 'currency', currency });
//     }
//   }
// }

//   boxes.forEach((box) => {
//     box.addEventListener('click', function () {
//       selectBox(this);
//     });
//   });

//   // default select first
//   setTimeout(() => selectBox(boxes[0]), 50);
//   document.dispatchEvent(new CustomEvent('variant:change'));
// }
let basePrice = null;
function parsePrice(text) {
  if (!text) return 0;

  let num = text.replace(/[^\d.,]/g, '');

  // EU format: 8,99 → 8.99
  if (num.includes(',') && !num.includes('.')) {
    num = num.replace(',', '.');
  }

  // remove thousand separators
  if (num.includes(',') && num.includes('.')) {
    num = num.replace(/,/g, '');
  }

  const value = parseFloat(num);
  return isNaN(value) ? 0 : value;
}

function getBasePrice() {
  const el = document.querySelector(".cstm-sample-price-value");
  if (!el) return 0;

  const price = parsePrice(el.textContent.trim());

  console.log("Base Price:", price);

  return price;
}

function formatPrice(amount) {
  const currencyCode = window.Shopify?.currency?.active || "EUR";

  const localeMap = {
    EUR: "de-DE",
    USD: "en-US",
    GBP: "en-GB",
    INR: "en-IN",
    CAD: "en-CA",
    AUD: "en-AU",
    AZN: "az-AZ"
  };

  const locale = localeMap[currencyCode] || "en-US";
  let symbol = currencyCode;
  try {
    const parts = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currencyCode,
      currencyDisplay: "narrowSymbol"
    }).formatToParts(0);

    const symbolPart = parts.find(p => p.type === "currency");
    if (symbolPart && symbolPart.value) {
      symbol = symbolPart.value;
    }
  } catch (e) {
    console.warn("Currency symbol nahi mila, fallback code use ho raha:", currencyCode);
  }

  const formattedNumber = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);

  // Final output: ₼44.00 AZN
  return `${symbol}${formattedNumber} ${currencyCode}`;
}
function updatePopupPrice(quantity) {
  const popup = document.querySelector(".cstm-sample-price-popup");
  if (!popup) return;

  const qty = Number(quantity);
  const safeQty = (!qty || qty <= 0) ? 1 : qty;

  if (!basePrice || basePrice <= 0) {
    basePrice = getBasePrice();
  }

  const finalPrice = basePrice * safeQty;

  console.log("Final Price:", finalPrice);

  popup.textContent = formatPrice(finalPrice);
}

basePrice = getBasePrice();
updatePopupPrice(1);
window.addEventListener("load", () => {
  const el = document.querySelector(".cstm-sample-price-value");

  console.log("RAW PRICE:", el?.textContent);

  basePrice = getBasePrice();

  console.log("BASE PRICE:", basePrice);
  // console.log("CURRENCY:", baseCurrencySymbol);
});
function initVariantBox() {
  const boxes = document.querySelectorAll('.cstm-sample-wrapper .cstm-sample-variant');
  if (!boxes.length) return;
 

  function getCurrencySymbol(currency) {
    const map = { INR: 'Rs.', USD: '$', EUR: '€', GBP: '£' };
    return map[currency] || '';
  }

  function formatPriceSimple(raw, isPaise = false) {
    const currency = window.Shopify?.currency?.active || 'INR';
    const symbol = getCurrencySymbol(currency);
    if (!raw) return '';

    let value = Number(String(raw).replace(/[^0-9.]/g, ''));
    if (isPaise) value = value / 100;

    const formattedNumber = value.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return `${symbol} ${formattedNumber}`;
  }

  function normalize(str) {
    return (str || '')
      .toLowerCase()
      .replace(/["'*]/g, '')
      .replace(/\+/g, ' ')
      .replace(/,/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getWords(str) {
    return normalize(str).split(/[\s\/\(\)]+/).filter(Boolean);
  }

  function selectBox(box) {
    const variantEl = box.querySelector('.cstm-sample-variant-id');
    const variantId = variantEl?.dataset?.id || variantEl?.id;
    

    document.querySelectorAll('.cstm-sample-variant')
      .forEach(b => b.classList.remove('active'));
    box.classList.add('active');

    resetQuantityToOne();
    
    let combinationVid = null;
    let combinationPrice = null;

    const newdropdown2 = document.querySelector('.new-dropdown-2');
    const dropdownLabel = newdropdown2?.querySelector('label')?.textContent?.trim()?.toLowerCase();
    const isCombinationDropdown = newdropdown2 && dropdownLabel !== 'color';

    if (isCombinationDropdown) {
      const sampleText = variantEl?.innerText?.trim() || '';

      const finish = newdropdown2.querySelector('.selectedOption')
        ?.dataset?.selected_option_val
        ?.toLowerCase()
        ?.trim();

      if (sampleText) {
        const sampleWords = getWords(sampleText);
        const finishWords = getWords((finish || '').replace(/-/g, ' '));

        console.log('sampleWords:', sampleWords);
        console.log('finishWords:', finishWords);

        let bestMatch = null;
        let bestScore = 0;

        document.querySelectorAll('.all_variants .variant_id_new').forEach(el => {
          const title = el.dataset.title || '';
          const titleWords = getWords(title);

          let score = 0;

          // Sample words score
          sampleWords.forEach(w => {
            if (titleWords.includes(w)) score++;
          });

          // Finish words score
          finishWords.forEach(w => {
            if (titleWords.includes(w)) score++;
          });

          console.log(`Title: "${title}" | Score: ${score}`);

          if (score > bestScore) {
            bestScore = score;
            bestMatch = el;
          }
        });

        if (bestMatch) {
          combinationVid   = bestMatch.dataset.vid;
          combinationPrice = bestMatch.dataset.price;
          console.log('BEST MATCH:', bestMatch.dataset.title, '| Score:', bestScore);
        }
      }

      console.log('Combination VID:', combinationVid, '| Fallback VID:', variantId);
    }

    const resolvedId = combinationVid || variantId;
    if (!resolvedId) return;

    document.querySelectorAll('input[name="id"]').forEach(input => {
      input.value = resolvedId;
    });

    if (!combinationVid) {
      const variantSelectEl = document.querySelector('variant-selects');
      if (variantSelectEl) {
        let matched = false;
        variantSelectEl.querySelectorAll('select').forEach(select => {
          Array.from(select.options).forEach(opt => {
            if (opt.value === resolvedId) {
              select.value = opt.value;
              matched = true;
            }
          });
        });
        if (matched) {
          variantSelectEl.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    const btn = document.querySelector('.cstm-sample-button');
    if (btn) btn.setAttribute('data-vid', resolvedId);

    const popupBtn = document.querySelector('.popup_product_form .sample_button');
    if (popupBtn) popupBtn.dataset.vid = resolvedId;

    const variantAvailable = variantEl?.dataset?.available;
    if (btn && variantAvailable !== undefined) {
      btn.classList.toggle('disabled', variantAvailable === 'false');
    }

    let rawFinalPrice = null;

    if (combinationPrice) {
      // combinationPrice already normal value hai (paise me nahi)
      rawFinalPrice = Number(String(combinationPrice).replace(/[^0-9.]/g, ''));
    } else if (variantEl?.dataset?.price) {
      // variant dataset price Shopify se paise/cents me aata hai
      rawFinalPrice = Number(String(variantEl.dataset.price).replace(/[^0-9.]/g, '')) / 100;
    }

    if (rawFinalPrice !== null && !isNaN(rawFinalPrice)) {
      // global basePrice update karo taaki quantity change pe sahi calculate ho
      basePrice = rawFinalPrice;

      const priceEl = document.querySelector('.cstm-sample-price-value');
      if (priceEl) priceEl.textContent = formatPrice(rawFinalPrice);

      // popup ko current quantity ke hisaab se recalculate karne do
      const qtyInputEl = document.querySelector('.cstm-product-form__color-wrapper .quantity__input');
      const currentQty = qtyInputEl ? Number(qtyInputEl.value) || 1 : 1;
      updatePopupPrice(currentQty);

      document.querySelectorAll(
        '.sample_button-new-variant span.s_price, .sample_popup_open span.s_price'
      ).forEach(el => {
        el.textContent = formatPrice(rawFinalPrice);
      });
    }
  }

  boxes.forEach(box => {
    box.addEventListener('click', function () {
      selectBox(this);
    });
  });

  setTimeout(() => selectBox(boxes[0]), 50);
  document.dispatchEvent(new CustomEvent('variant:change'));
}

// ── Finish dropdown change → re-run selectBox on active box ──────────────
document.addEventListener('click', function (e) {
  const li = e.target.closest('.new-dropdown-2 .scrollableList ul li');
  if (!li) return;
  setTimeout(() => {
    const activeBox = document.querySelector('.cstm-sample-wrapper .cstm-sample-variant.active');
    if (activeBox) selectBox(activeBox);
  }, 50);
});


function updateCartUI() {
  fetch('/?sections=cart-drawer,cart-icon-bubble')
    .then(res => res.json())
    .then(data => {
        $("cart-drawer-items").html($(data["cart-drawer"]).find("cart-drawer-items").html());
        $("#cart-icon-bubble").html($(data["cart-icon-bubble"]).html());
        $("cart-drawer").removeClass("is-empty");
        $(".drawer__inner-empty").hide();

        $("cart-drawer").load("/cart #CartDrawer", function () {
            document.querySelector('#cart-icon-bubble').click();
        });
    });
}
function openPersonalizeColorPopup(e) {
  const popup = document.getElementById('customizeModal');
  if (!popup) return;

  popup.style.display = 'grid';
  popup.classList.add('active-personalize-popup');
  document.body.classList.add('personalize-open');

  const mainModalContent = popup.querySelector('.main-content-model');
  if (mainModalContent) {
    mainModalContent.classList.add('mainModalContent');
  }

  const saveButton = popup.querySelector('#saveButton');
  if (saveButton) {
    saveButton.textContent = 'Confirm colors and Continue to Buy a sample';
  }
  function syncColors() {
    const bgCircleColor = $('.color_circle_div1 .color_circle').data('color-value');
    const designCircleColor = $('.color_circle_div2 .color_circle').data('color-value');

    // BACKGROUND SYNC
    if (bgCircleColor) {
      $('.color_popup .current-class')
        .attr('data-class', '.cls-2')
        .attr('data-type', 'Background');

      const $bgMatch = $(
        '.color_list_li .color_holder[data-code="' + bgCircleColor + '"]'
      );

      if ($bgMatch.length) {
        console.log('Background synced:', bgCircleColor);
        $bgMatch.trigger('click');
      }
    }

    // DESIGN SYNC
    if (designCircleColor) {
      $('.color_popup .current-class')
        .attr('data-class', '.cls-1')
        .attr('data-type', 'Design');

      const $designMatch = $(
        '.color_list_li .color_holder[data-code="' + designCircleColor + '"]'
      );

      if ($designMatch.length) {
        console.log('Design synced:', designCircleColor);
        $designMatch.trigger('click');
      }
    }
    $('.color_circle_div1 .color_circle').trigger('click');
  }
  requestAnimationFrame(() => {
    setTimeout(syncColors, 100);
  });
  $(document)
    .off('click.personalizeBg')
    .on('click.personalizeBg', '.color_circle_div1 .color_circle', function () {
      const color = $(this).data('color-value');
      if (!color) return;

      $('.color_popup .current-class')
        .attr('data-class', '.cls-2')
        .attr('data-type', 'Background');

      $('.color_list_li .color_holder[data-code="' + color + '"]').trigger('click');
    });

  $(document)
    .off('click.personalizeDesign')
    .on('click.personalizeDesign', '.color_circle_div2 .color_circle', function () {
      const color = $(this).data('color-value');
      if (!color) return;

      $('.color_popup .current-class')
        .attr('data-class', '.cls-1')
        .attr('data-type', 'Design');

      $('.color_list_li .color_holder[data-code="' + color + '"]').trigger('click');
    });
}
$(document).on('click', '.personalize_color', function (e) {
  e.preventDefault();
  e.stopPropagation();
  const popup = document.getElementById('samplePopup');
  if (!popup) return;
  popup.style.display = 'none';
  popup.classList.remove('new-sample-variants-open');
  setTimeout(function(){
  openPersonalizeColorPopup();
  
  },500);

});
// Open sample popup selectors
// $(document).on('click', '.sample_personalize_colors_one, .sample_personalize_colors_all, .sample_personalize_colors_two , .sample_personalize_colors_none', function (e) {
//   e.preventDefault();
//   e.stopPropagation();
  
//   const popup = document.getElementById('samplePopup');
//   if (!popup) return;
  
//   popup.style.display = 'grid';
//   popup.classList.add('new-sample-variants-open');
//    $('#color-error').remove();
//    const input = document.querySelector('#popup_color_picker_new');
//     if (input) {
//       input.value = '';
//       input.setAttribute('value', '');
//     }
  
//   setTimeout(() => { initVariantBox(); }, 200);
// });





function initPopupQty() {
  const wrapper = document.querySelector('.cstm-product-form__color-wrapper');
  if (!wrapper) return;

  const minusBtn = wrapper.querySelector('button[name="minus"]');
  const plusBtn = wrapper.querySelector('button[name="plus"]');
  const input = wrapper.querySelector('.quantity__input');

  if (!minusBtn || !plusBtn || !input) return;

  if (minusBtn.dataset.cloned) return;

  const newMinus = minusBtn.cloneNode(true);
  const newPlus = plusBtn.cloneNode(true);

  newMinus.dataset.cloned = 'true';
  newPlus.dataset.cloned = 'true';

  minusBtn.replaceWith(newMinus);
  plusBtn.replaceWith(newPlus);

  newMinus.addEventListener('click', function (e) {
    e.preventDefault();

    let val = parseInt(input.value) || 1;
    const min = parseInt(input.min) || 1;

    if (val > min) val--;

    input.value = val;
    input.setAttribute('value', val);
    
    updatePopupPrice(val);
    syncMainQty(val);

    // console.log("Popup Minus:", val);
  });

  newPlus.addEventListener('click', function (e) {
    e.preventDefault();

    let val = parseInt(input.value) || 1;
    val++;

    input.value = val;
    input.setAttribute('value', val);
    updatePopupPrice(val);
    syncMainQty(val);

    // console.log("Popup Plus:", val);
  });

}
function syncMainQty(value) {
  const mainInput = document.querySelector(
    '.product__info-wrapper.grid__item .product-form__input.product-form__quantity .quantity__input'
  );

  if (!mainInput) return;

  mainInput.value = value;
  mainInput.setAttribute('value', value);

  // trigger events so Shopify/theme updates properly
  mainInput.dispatchEvent(new Event('input', { bubbles: true }));
  mainInput.dispatchEvent(new Event('change', { bubbles: true }));

}
function resetQuantityToOne() {
  const mainInput = document.querySelector(
    '.product__info-wrapper.grid__item .product-form__input.product-form__quantity .quantity__input'
  );

  const popupInput = document.querySelector(
    '.cstm-product-form__color-wrapper .quantity__input'
  );
  const cstmSamplePricePopup= document.querySelector(".cstm-sample-popup .cstm-sample-price-popup");
  cstmSamplePricePopup.style.display = "none"; 

  const newValue = 1;

  if (mainInput) {
    mainInput.value = newValue;
    mainInput.setAttribute('value', newValue);
    mainInput.dispatchEvent(new Event('input', { bubbles: true }));
    mainInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  if (popupInput) {
    popupInput.value = newValue;
    popupInput.setAttribute('value', newValue);
    
  }
  setTimeout(() => {
      const minusBtn_clicked = document.querySelector(
          '.cstm-sample-popup quantity-input .quantity__button[name="minus"]'
        );


    if (minusBtn_clicked) {
      minusBtn_clicked.dispatchEvent(new MouseEvent("click", {
        bubbles: true
      }));
     cstmSamplePricePopup.style.display = "block"; 
    }
  }, 300);
   
  console.log("Both quantities reset to 1");
}

// setTimeout(() => {
//   const btn = document.querySelector('button.cstm-sample-button[type="submit"]');
//   if (btn) btn.click();
// }, 2000);
$(document).on('click', '.sample_personalize_colors_one, .sample_personalize_colors_all, .sample_personalize_colors_two, .sample_personalize_colors_none , .sample_personalize_count', function(e) {
  e.preventDefault();
  e.stopPropagation();

  const popup = document.getElementById('samplePopup');
  if (!popup) return;

  popup.style.display = 'grid';
  popup.classList.add('new-sample-variants-open');
  $('#color-error').remove();

  setTimeout(() => {
    initVariantBox();
    const input = document.querySelector('#popup_color_picker_new');
    if (input) {
      input.value = '';
      input.setAttribute('value', '');
    }
    setTimeout(function(){
    const minusBtn = document.querySelector(
        '.cstm-sample-popup quantity-input .quantity__button[name="minus"]'
      );
    const cstmSamplePricePopup= document.querySelector(".cstm-sample-popup .cstm-sample-price-popup");
    cstmSamplePricePopup.style.display = "block"; 
    minusBtn.click();
    },400)
   
    initPopupQty(); 
    resetQuantityToOne();
  }, 300);
});
function initColorDefaultSelection() {

  const wrapper =
    $('.cstm_select-menu_color_pdp_sample_popup, .cstm_color_sample_nodropdown');

  wrapper.each(function () {

    const $wrap = $(this);

    const items = $wrap.find('.options, .option');

    const firstItem = items.first();

    if (!firstItem.length) return;

    // default active
    items.removeClass('active');
    firstItem.addClass('active');

    updateColorValue(firstItem);

    // click event
    items.on('click', function () {

      items.removeClass('active');

      $(this).addClass('active');

      updateColorValue($(this));
    });

  });
}
function initSamplePopupDropdown() {

  // open close dropdown
  $('.select-btn_sample_popup').off('click').on('click', function (e) {

    e.stopPropagation();

    const wrapper = $(this).closest(
      '.cstm_select-menu_color_pdp_sample_popup'
    );

    $('.cstm_select-menu_color_pdp_sample_popup')
      .not(wrapper)
      .removeClass('active');

    wrapper.toggleClass('active');

  });

  // option select
  $('.options_sample_popup .options')
    .off('click')
    .on('click', function () {

      const colorName = $(this).data('color-name');

      const colorValue = $(this).data('color-value');

      // =========================
      // UPDATE ALL DROPDOWNS
      // =========================

      // update all selected names
      $('.cstm_select_name_circle_selected')
        .text(colorName);

      // update all selected colors
      $('.cstm_select_color_circle_sample_popup_selected')
        .css({
          background: colorValue,
          border: '1px solid ' + colorValue
        });

      // update all hidden inputs
      $('.color_properties_1')
        .val(colorName + ' - ' + colorValue);

      // active option sync
      $('.options_sample_popup .options')
        .removeClass('active');

      $(
        '.options_sample_popup .options[data-color-name="' + colorName + '"]'
      ).addClass('active');

      // close all dropdowns
      $('.cstm_select-menu_color_pdp_sample_popup')
        .removeClass('active');

    });

  // outside click close
  $(document).off('click.samplePopup').on('click.samplePopup', function () {

    $('.cstm_select-menu_color_pdp_sample_popup')
      .removeClass('active');

  });

}
function updateColorValue(item) {

  const name =
    item.data('colorName') || item.attr('data-color-name') || '';

  const value =
    item.data('colorValue') || item.attr('data-color-value') || '';

  const structuredValue =
    (name && value)
      ? `${name.trim()} - ${value.trim()}`
      : (name || value);

  $('.color_properties_1').val(structuredValue);
}
setTimeout(() => {
  initColorDefaultSelection();
  initSamplePopupDropdown();
}, 1000)
// FIXED: Listen to the active layout click events across custom options

$(document).on('click', '.modal .color_holder', function () {

  const wrapper = $(this).closest('.color_popup');

  wrapper.find('.color_holder').removeClass('active');
  $(this).addClass('active');

  const name = $(this).data('color-value') || '';
  const code = $(this).data('code') || '';


  console.log("name:", name);
  console.log("code:", code);

  // 🔥 IMPORTANT: get correct type from clicked swatch group
  const type = wrapper.find('.current-class').attr('data-type'); 
  // OR better fallback:
  const fallbackType = $(this)
    .closest('.color_popup')
    .find('.current-class')
    .data('type');

  const finalType = type || fallbackType;

  const finalValue = name && code
    ? `${name} - ${code}`
    : (name || code);

  // ✅ DO NOT overwrite wrong field
  if (finalType === 'Background') {
    $('.product-form input[name="properties[Background]"]').val(finalValue);
  }

  if (finalType === 'Design') {
    $('.product-form input[name="properties[Design]"]').val(finalValue);
  }

  console.log("TYPE:", finalType, "FINAL:", finalValue);
});

// Add to Cart Submission Handler
$(document).on('click', '.cstm-sample-button', function (e) {
  e.preventDefault();
  e.stopPropagation();

  const cstmSampleForm =  document.querySelector(".cstm-sample-form-wrapper .personalize_color");
  if(cstmSampleForm){
     return;
  }
  const submitBtn = $(this);
  const popup = document.getElementById('samplePopup');

  submitBtn.prop('disabled', true);
  console.log(submitBtn)
  let colorInput = document.getElementById('popup_color_picker_new');
  let colorValue = colorInput ? colorInput.value.trim() : '';
   if (colorInput) {
    if (colorInput) {
      colorInput.addEventListener('input', () => {
        let val = colorInput.value.trim();
        if (val !== '') {
          $('#color-error').remove();
          colorInput.style.removeProperty('border');
        }
      });
    }



    // Fallback to checking the standard dropdown hidden inputs if custom variant selection is activated
     let all_colors_dropdowns = document.querySelector(".select-btn_sample_popup-more")
    if (all_colors_dropdowns) {
    if (!colorValue) {
      colorValue = $('.color_properties_1').val() || $('.color_properties').val() || '';
    }
  }

    if (!colorValue) {
      submitBtn.prop('disabled', false);
      if(!document.getElementById('color-error')) {
        $('.cstm-svg-preferred-color.field').after(`
          <div id="color-error" style="color:red;font-size:12px;margin-top:5px;">
            Please enter color
          </div>
        `);
      }
      colorInput?.focus();
      return;
    }
  }

  let variantId = submitBtn.attr('data-vid');
  // let dataAvailable=submitBtn.attr(data-available);
  console.log(variantId)
  if (!variantId) {
    submitBtn.prop('disabled', false);
    // alert('Select variant first');
    return;
  }

  let qtyInput = document.querySelector('.quantity__input');
  let width = parseFloat($('#wallpaper-width').val());
  let rollQty = 1;

  if (!isNaN(width) && width > 0) {
    rollQty = Math.ceil(width / 24);
  }
  if (qtyInput) {
    let userQty = parseInt(qtyInput.value);
    if (!isNaN(userQty) && userQty > 0) {
      rollQty = userQty;
    }
  }

  let properties = {};
  let sample_popup_open = document.querySelector(".sample_button");
  let current = sample_popup_open ? Number(sample_popup_open.getAttribute("getpopup")) : 0;

  $(".line-item-property__field").each(function () {
    const $field = $(this);
    const labelText = $field.find("label").text().replace("*", "").trim();
    let value = ($field.find(".field__input").val() || "").trim();

    if (!labelText || properties[labelText]) return;
    if (!value || value.startsWith("#")) value = "Default";
    let finalValue = value;
    // alert(value);
    if (labelText.toLowerCase().includes("personalisation")) {
      finalValue = (value && value !== "Default") ? value : "";
    } else {
      if (current === 2) finalValue = value;
      else if (current === 0 || current === 1) finalValue = "Default";
    }
    properties[labelText] = finalValue;
  });

  // FIXED: Properly prioritize the custom color selection output over default fallbacks
  if (colorValue && colorValue.trim() !== "") {
    properties["Color"] = colorValue;
  }
  // } else {
  //   properties["Color"] = "Default";
  // }
 
    let all_colors_dropdown = document.querySelector(".select-btn_sample_popup-more");
    
  if (all_colors_dropdown ) {
 var colorValues = document.querySelector('.color_properties_1')?.value || '';
    properties["Color"] = colorValues;
  }

  // submitBtn.find('.loading-overlay__spinner').removeClass('hidden');
  console.log(properties);
  const bodyData = {
    id: variantId,
    quantity: rollQty,
    properties: properties
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(bodyData)
  })
  .then(res => res.json())
  .then(() => {
    submitBtn.prop('disabled', false);
    submitBtn.find('.loading-overlay__spinner').addClass('hidden');
    if (popup) popup.style.display = 'none';
     setTimeout(() => {
       resetQuantityToOne();
     }, 2000);
    if (typeof updateCartUI === "function") updateCartUI();
  })
  .catch((err) => {
    console.error(err);
    submitBtn.prop('disabled', false);
    submitBtn.find('.loading-overlay__spinner').addClass('hidden');
  });
});
// For disable button
$(document).on('click', '.cstm-sample-variant', function () {
  const selectedId = $(this).find('span').attr('id');
  const btn = document.querySelector('.cstm-sample-button');
  
  // Button pe jo data-available hai wo check karo
  const selectedOption = document.querySelector(`.variant_id_new[data-vid="${selectedId}"]`);
  const isAvailable = selectedOption ? selectedOption.getAttribute('data-available') : 'true';
  
  if (isAvailable === 'false') {
    $(btn).prop('disabled', true).css({ 'opacity': '0.5', 'cursor': 'not-allowed' });
  } else {
    $(btn).prop('disabled', false).css({ 'opacity': '1', 'cursor': 'pointer' });
  }
});
// end disable button
if (
$(".sample_button").is('.sample_personalize_colors_one, .sample_personalize_colors_all, .sample_personalize_colors_two , .sample_personalize_colors_none , .sample_personalize_count')) {
}else{
  $(document).on('click', '.sample_button.product-form__submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
          
            const popup = document.getElementById('pdpPopup');
            if (popup && popup.classList.contains('popup_overlay') && popup.classList.contains('active')) {
              if (document.getElementById('popup_color_picker_2')) {

                let colorInput_2 = document.getElementById('popup_color_picker_2');
                console.log(colorInput_2);

                colorInput_2.addEventListener('input', () => {
                  let colorValue = colorInput_2.value.trim();

                  if (colorValue !== '') {
                    let existingError = document.getElementById('color-error');
                    if (existingError) {
                      existingError.remove();
                    }
                    colorInput_2.style.removeProperty('border');
                  }
                });

                let colorValue2 = colorInput_2.value.trim();

                let existingError = document.getElementById('color-error');
                if (existingError) {
                  existingError.remove();
                  colorInput_2.style.removeProperty('border');
                }

                if (colorValue2 === '') {
                  let errorMsg = document.createElement('div');
                  errorMsg.id = 'color-error';
                  errorMsg.style.color = 'red';
                  errorMsg.style.marginTop = '5px';
                  errorMsg.innerText = 'Please fill the color';

                  colorInput_2.parentNode.appendChild(errorMsg);

                  colorInput_2.style.setProperty('border', '1px solid red', 'important');

                  return;
                }
              }
            }
            setTimeout(() => {
              let sample_popup_open = document.querySelectorAll(".sample_button");
              sample_popup_open.forEach((el) => {
                  let current = Number(el.getAttribute("getpopup"));
                  el.setAttribute("getpopup",0);
                });
            }, 1500);

            const PDP_TARGET_SELECTOR_2 = ".wallpaper-size-calculator";
              let roomvoBtn_2 = null;
              let pdpTarget_2 = null;

              function setPDPStyle_2(btn) {
                btn.innerHTML = "";
                btn.append(" See this in my room");
              }

              const observer = new MutationObserver(() => {
                roomvoBtn_2 = document.querySelector(".popup_details .popup_content .inside_popup .popup_content_1 .wallpaper_button button.roomvo-stimr.processed");
                pdpTarget_2 = document.querySelector(PDP_TARGET_SELECTOR_2);

                if (pdpTarget_2 && roomvoBtn_2) {
                  pdpTarget_2.insertAdjacentElement("afterend", roomvoBtn_2);
                  setPDPStyle_2(roomvoBtn_2);

                  const popup = document.getElementById("pdpPopup");
                  if (popup) popup.classList.remove("active");
                  document.body.classList.remove("active");
                  observer.disconnect(); // Stop observing once done
                }
              });

              // Start observing the body for changes
            observer.observe(document.body, { childList: true, subtree: true });
            setTimeout(() => {
              observer.disconnect();
              console.log("Observer stopped by timeout");
            }, 2000);

            const form = document.querySelector(".product-form .form");
            if (form && !form.checkValidity()) {
                form.reportValidity();
                return;
            }
            const variantId = $('.sample_button.product-form__submit').attr('data-vid');
            const qtyInput = document.querySelector(".quantity__input");
            //const width = parseFloat($.trim($("#wallpaper-width").val()));
            //const height = parseFloat($.trim($("#wallpaper-height").val()));
            const width = parseFloat(String($("#wallpaper-width").val() || "").trim());
            const height = parseFloat(String($("#wallpaper-height").val() || "").trim());
            
            let rollQty = 1; // default

            if (!isNaN(width) && !isNaN(height) && width > 0 && height > 0) {
                rollQty = Math.ceil(width / 24);
            }
            if (qtyInput) {
                const userQty = parseInt(qtyInput.value);
                if (!isNaN(userQty) && userQty > 0) {
                    rollQty = userQty;
                }
            }
            
            let properties = {};
            console.log("----------------properties");

            $(".line-item-property__field").each(function () {

                const $field = $(this);
                const labelText = $field.find("label").text().replace("*", "").trim();
                let value = ($field.find(".field__input").val() || "").trim();

                if (!labelText || properties[labelText]) return;

                // Normalize
                if (!value || value.startsWith("#")) {
                    value = "Default";
                }

                let popupMode = null;

                document.querySelectorAll(".sample_button").forEach((el) => {
                    popupMode = Number(el.getAttribute("getpopup"));
                });

                let finalValue = value;
                if (labelText.toLowerCase().includes("personalisation")) {
                    finalValue = (value && value !== "Default") ? value : "";

                } 
                else {
                    if (popupMode === 2) {
                        finalValue = value;
                    } 
                    else if (popupMode === 0 || popupMode === 1) {
                        finalValue = "Default";
                    }
                }

                properties[labelText] = finalValue;

                console.log(labelText + ":", properties[labelText]);
            });

      
          const colorValue = document.querySelector('.color_properties_1')?.value || '';
          const colorValue_sample_pdp = document.querySelector('.color_properties')?.value || '';
          let sample_popup_open = document.querySelector(".sample_button");
                let current = Number(sample_popup_open.getAttribute("getpopup")) ;
              if(colorValue){
                if(colorValue){
                  properties["Color"] = colorValue;       
                }
                else if(current==1){
                properties["Color"] = colorValue;
                  }
                  else if(current==0 ){
                    properties["Color"] ="Default"
                  }

              } 
            const bodyData = {
                id: variantId,
                quantity: rollQty,
                properties: properties
            };
            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(bodyData)
            })
            .then(res => res.json())
            .then(() => {
                fetch('/?sections=cart-drawer,cart-icon-bubble')
                    .then(res => res.json())
                    .then(data => {
                        $("cart-drawer-items").html(
                            $(data["cart-drawer"]).find("cart-drawer-items").html()
                        );
                        $("#cart-icon-bubble").html(
                            $(data["cart-icon-bubble"]).html()
                        );
                        $("cart-drawer").removeClass("is-empty");
                        $(".drawer__inner-empty").hide();

                        $("cart-drawer").load("/cart #CartDrawer", function () {
                            document.querySelector('#cart-icon-bubble').click();
                        });
                    });
            });
            return false;
  });
}
// End the code March 19

/** Add attribute to the product form**/

$('.product-form__buttons button').click(function(e){
  $(this).parents('.product-form').attr('data-type',$(this).attr('data-type'));
  
  
});
/** Add attribute to the product form END HERE**/
    /*** convert select to ul li ***/
 

/*** product page covert select to ul li ***/

      $('.product-form__input--dropdown .select__select').each(function (index, element) {
      var selected_option = $('option:selected',this).text();
       var selected_option_val = $('option:selected',this).attr('data-value');
      if(selected_option_val.indexOf('sample') > -1){
        var select_id= $(this).attr('id');
        $('option:selected',this).removeAttr('selected');
        $('option:eq(2)',this).attr('selected', 'selected');
        eventFire(document.getElementById(select_id), 'change');
        var selected_option = $('option:selected',this).text();
       var selected_option_val = $('option:selected',this).attr('data-value'); 
      }
       var select_icon =$(this).next('.icon-caret');
        $(this).parent()
            .after()
            .append("<div class='scrollableList'><div class='selectedOption'></div><ul></ul></div>");
              $(select_icon).insertBefore($(this).parents('.select').find('.selectedOption'));  
        $(element).each(function (idx, elm) {
            $('option', elm).each(function (id, el) {
              if($(this).attr('data-value').indexOf('sample') == -1){
                $('.scrollableList ul:last').append('<li data-val="'+$(this).attr('data-value')+'" data-value="'+el.value+'">' + el.text + '</li>');
              }
              });
            $('.scrollableList ul').hide();
         
        });
        $('.scrollableList:last').children('div.selectedOption').text(selected_option).attr('data-selected_option_val',selected_option_val);
    });

    $('.selectedOption').on('click', function () {
        $(this).next('ul').slideToggle(200);
        $('.selectedOption').not(this).next('ul').hide();
    });

    // Merge the code March 19
    $(document).on('click', '.scrollableList ul li', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var selectedLI = $(this).text();
      $(this)
          .parent()
          .prev('.selectedOption')
          .text(selectedLI)
          .attr('data-selected_option_val', $(this).attr('data-val'));

      $(this).parent('ul').hide();
      var selected_value = $(this).attr('data-val');
      let parentSelect = $(this).closest('.select');
      parentSelect.find('select option:selected').removeAttr('selected');
      parentSelect
          .find('select option[data-value="' + selected_value + '"]')
          .attr("selected", "selected");
      var select_id = parentSelect.find('select').attr('id');
      // alert(select_id);
      eventFire(document.getElementById(select_id), 'change');
      // alert(eventFire)
    });
    // End the code March 19
    $('.scrollableList').show();
    $('.select__select').hide();

  
$(document).on("click", "ul.product-option-ul .init , .dropdown-icon", function() {
  $(this).closest("ul").find('.innerLi').toggle();
});

   /*** convert select to ul li END HERE***/
  $('html').click(function(event) {
    if ($(event.target).closest('.scrollableList ul, .scrollableList').length === 0) {
        $('.scrollableList ul').hide();
    }
});
      
  // Merge the code March 19
  // let newdropdown2 = document.querySelector(".new-dropdown-2");

  // if (newdropdown2) {
  //     let scrollableList = newdropdown2.querySelector(".scrollableList");

  //     if (scrollableList) {
  //         scrollableList.addEventListener("click", function (event) {
  //             let li = event.target.closest("li");
  //             if (!li) return;

  //             let value = li.getAttribute("data-val");
  //             let text = li.getAttribute("data-value");

  //             console.log("Selected value:", value);
  //             console.log("Selected text:", text);
  //             let variant_details = document.querySelector(".variant_detail");
  //             console.log(variant_details);
  //             let variantId = null;
  //             document.querySelectorAll(".variant_id").forEach((item) => {
  //                 let title = item.getAttribute("data-title");

  //                 // Match selected text with variant title
  //                 if (title && title.includes(text)) {
  //                     variantId = item.getAttribute("data-vid");
  //                 }
  //             });
  //           let button = document.querySelector(".sample_button");
  //           console.log(button);
  //           if (button && variantId) {
  //               button.getAttribute("data-vid");
  //               button.setAttribute("data-vid",variantId)
  //           }

  //             console.log("Matched Variant ID:", variantId);
            

  //             // Optional: update real select (if needed by theme)
  //             let select = newdropdown2.querySelector("select");
  //             if (select) {
  //                 select.value = text;
  //                 select.dispatchEvent(new Event("change", { bubbles: true }));
  //             }
  //         });
  //     }
  // }
  // End the code March 19
  $(document).on("click", "ul.product-option-ul li:not(.init)", function() {
   $("ul.product-option-ul .innerLi li").removeClass('selected');
    $(this).addClass('selected');
    // var selected_value = $.trim($(this).attr('data-value'));
    var selected_value = $(this).attr('data-value').trim();
    
    $(this).parents('ul').children('.init').html($(this).text());
  $(this).parents('ul').children('.init').attr('data-value',selected_value);    
    $(this).closest("ul").find('.innerLi').toggle();
     var select_id= $(this).parents('ul').attr('data-option'); 
  $('#SortBy option').removeAttr('selected');
  $('#SortBy option[value="'+selected_value+'"]').attr("selected", "selected");    
$('#SortBy').trigger('change');
  eventFire(document.getElementById('SortBy'), 'click');
  var url = window.location.href;
  var sort_by = 'sort_by='+selected_value;
  var href = new URL(window.location.href);
    if(window.location.href.indexOf('sort_by') > -1){
      href.searchParams.set('sort_by', selected_value);
 window.history.pushState({href: window.location.href}, '', href.toString());
      url = href.toString();
    }
    else{
       url =  url+'?'+sort_by;
         window.history.pushState({href: window.location.href}, '', url);
    }      
$.ajax({
        type: 'get',
        url:url,
        dataType: "html",
        success: function(result){ 
           $('#ProductGridContainer').html($(result).find('#ProductGridContainer'));
         
        }
    });
                 
});
  $('.sort_list').click(function(){
    $('.sort_icon').toggleClass('active');   
  });
  $('.sort_icon').click(function(){
   $('.innerLi').slideToggle();
    $('.sort_icon').toggleClass('active'); 
 });



// Prevent events from getting pass .popup
 $(document).on("click", function(event){
        var $trigger = $(".product-option-ul");
       if (!$trigger.is(event.target) && $trigger.has(event.target).length === 0) {
        $trigger.find('.innerLi').hide();
         $trigger.find('.sort_icon').removeClass('active');
        }            
    });
});  

// Calculator label icon popup

 $(".calculator_pop").on('click', function() {
  $(".custom-model-main").addClass('model-open');
}); 
$(".close-btn, .bg-overlay").click(function(){
  $(".custom-model-main").removeClass('model-open');
});
 $(document).mouseup(function (e) { 
            if ($(e.target).closest(".custom-model-inner").length === 0 ) { 
             $('.custom-model-main').removeClass('model-open');    
            } 
        }); 


document.addEventListener("DOMContentLoaded", () => {
  const slider = $('.cstm-blocks-container-inner');
  if (slider.length > 0) {
  let hasStarted = false;
  function updateMuteUI(video, btn) {
    if (!btn || btn.length === 0) return;
    btn.removeClass('unmuted muted');
    if (video.muted) {
      btn.addClass('muted');
    } else {
      btn.addClass('unmuted');
    }
  }

  function stopAllVideos() {
    slider.find('video').each(function() {
      this.pause();
      this.currentTime = 0;
    });
  }
  function playCenterVideo() {
    const slick = slider.slick('getSlick');

    const realIndex = slick.currentSlide % slick.slideCount;
    const centerSlide = $(slick.$slides.get(realIndex));

    const video = centerSlide.find('video').get(0);
    const muteBtn = centerSlide.find('.custom-mute-btn');

    if (!video) return;

    stopAllVideos();

    if (video.dataset.userMuted === undefined) {
      video.muted = true;
      video.dataset.userMuted = "true";
    }

    updateMuteUI(video, muteBtn);

    const playPromise = video.play();
    if (playPromise) {
      playPromise.catch(() => {
        video.muted = true;
        video.dataset.userMuted = "true";
        video.play();
      });
    }

      video.onended = null;

    video.addEventListener('ended', function () {
      const slick = slider.slick('getSlick');

      // current real index nikaalo
      let currentIndex = slick.currentSlide % slick.slideCount;
      if (currentIndex < 0) {
        currentIndex = slick.slideCount + currentIndex;
      }

      // next index
      let nextIndex = currentIndex + 1;

      // loop back to first
      if (nextIndex >= slick.slideCount) {
        nextIndex = 0;
      }

      // force go to correct slide
      slider.slick('slickGoTo', nextIndex);
    }, { once: true });
  }
  slider.on('init', function() {
    setTimeout(() => {
        slider.find('.slick-slide').each(function() {
          const v = $(this).find('video').get(0);
          const m = $(this).find('.custom-mute-btn');
          if (v && m.length > 0) updateMuteUI(v, m);
        });
    }, 100);
  });

  slider.slick({
    infinite: true,
    centerMode: true,         
    centerPadding: '60px',    
    slidesToShow: 5,          
    slidesToScroll: 1,
    arrows: true,
    speed: 500,
    cssEase: 'ease-in-out',
    prevArrow: `<button type="button" class="slick-prev custom-arrow prev-arrow"><svg viewBox="0 0 10 6"><path d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/></svg></button>`,
    nextArrow: `<button type="button" class="slick-next custom-arrow next-arrow"><svg viewBox="0 0 10 6"><path d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/></svg></button>`,
    responsive: [{ breakpoint: 768, settings: { slidesToShow: 1, centerPadding: '40px' } }]
  });

  slider.on('afterChange', function() {
    playCenterVideo();
  });

  // Slide click handler (Clones par bhi kaam karega)
  $(document).on('click', '.slick-slide', function() {
    if (!$(this).hasClass('slick-center')) {
      const index = $(this).data('slick-index');
      slider.slick('slickGoTo', index);
    }
  });
  $(document).on('click', '.custom-mute-btn', function(e) {
    e.stopPropagation();

    const btn = $(this);
    const slide = btn.closest('.slick-slide');
    const video = btn.closest('.video-wrapper').find('video').get(0);

    if (!video) return;

    const index = slide.data('slick-index');

    const slick = slider.slick('getSlick');
    const isCenter = $(slick.$slides.get(slick.currentSlide)).is(slide);
    if (!isCenter) {

      slider.slick('slickGoTo', index);

      setTimeout(() => {
        video.pause();
        video.currentTime = 0;
        video.muted = !video.muted;
        video.dataset.userMuted = video.muted ? "true" : "false";

        updateMuteUI(video, btn);

        video.play().catch(() => {
          video.muted = true;
          video.play();
        });

      }, 200);
    } 
    else {
      video.muted = !video.muted;
      video.dataset.userMuted = video.muted ? "true" : "false";

      updateMuteUI(video, btn);
    }
  });
  // Intersection Observer
  const section = document.querySelector('.video-carousel');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !hasStarted) {
        hasStarted = true;
        setTimeout(() => playCenterVideo(), 600);
      }
    });
  }, { threshold: 0.5 });

  if (section) observer.observe(section);
  function setEqualHeight() {
  let maxHeight = 0;

  $('.video-card.cstm-block-vid-outer').css('height', 'auto');

  $('.video-card.cstm-block-vid-outer').each(function () {
    const h = $(this).outerHeight();
    if (h > maxHeight) maxHeight = h;
  });

  $('.video-card.cstm-block-vid-outer').css('height', maxHeight + 'px');
}

$(window).on('load resize', function () {
  setEqualHeight();
});

slider.on('afterChange', function () {
  setEqualHeight();
});
  }
});

